import { Observable, Subscription } from "rxjs";

import swal from "bootstrap-sweetalert";
import * as _ from 'lodash';
import { saveAs } from "file-saver";

import { Component, OnInit, OnDestroy, ChangeDetectorRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Response } from "@angular/http";

import { PlannedService } from "app/models/plannedService";
import { PlannedServiceService } from "app/services/plannedService.service";
import { BsLocaleService } from "ngx-bootstrap";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { FileStorageService } from "app/services/fileStorage.service";
import { Lightbox } from "angular2-lightbox";
import { ProfileService } from "app/services/profile.service";
import { PhotoType } from "app/models/photoDataPhotoType";

@Component({
  templateUrl: './plannedService-details.component.html',
  styleUrls: ['./plannedService-details.component.scss']
})
export class PlannedServiceDetailsComponent implements OnInit, OnDestroy {

  private _plannedService: PlannedService;
  private _errorState: PlannedServiceDetailsComponent.ErrorState = PlannedServiceDetailsComponent.ErrorState.None;
  private _photos: Array<any> = [];
  private _plannedServiceStatus = PlannedService.Status;
  private canAccessPhotos: boolean

  constructor(
    private _route: ActivatedRoute,
    private _plannedServiceService: PlannedServiceService,
    private _fileStorage: FileStorageService,
    private _changeDetector: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private _profileService: ProfileService,
    private router: Router,
    private _localeService: BsLocaleService,
    private _domSanitizer: DomSanitizer,
    private _lightbox: Lightbox) {
    this.canAccessPhotos = this._profileService.checkHasAccessPhotoPermission();
  }

  ngOnDestroy(): void {
    this.clearSubscription();
    swal.close();
  }

  ngOnInit(): void {
    this.loadData();
  }

  private loadData(): void {
    this._errorState = PlannedServiceDetailsComponent.ErrorState.None;

    let plannedServiceId: number = +this._route.snapshot.params['id'];
    this.clearSubscription();

    this._plannedServiceService.getPlannedServiceDetails(plannedServiceId)
      .subscribe(plannedService => {

        this._plannedService = plannedService;

      }, error => {
        if (error instanceof Response && (error.status == 403 || error.status == 404)) {
          this.router.navigateByUrl('/pagenotfound');
        } else {
          this._errorState = PlannedServiceDetailsComponent.ErrorState.UnknownError;
          swal({
            title: 'Ошибка',
            text: 'Не удалось получить данные обращения. Попробуйте снова',
            type: 'error',
            confirmButtonText: 'Попробовать еще раз'
          }, () => {
            this.loadData();
          });
        }
      });

  }

  //Открытие фотографии в lightbox'e
  private openPhoto(fileId: string): void {

    let index = _.findIndex(this._photos, { fileId: fileId });

    this._lightbox.open(this._photos, index);
  }

  //Получение Blob'а фотографии для отображения
  private getPhoto(fileId: string, type: PhotoType): Observable<any> {

    let url = this._fileUrls[fileId];

    if (url == null) {
      url = this._fileStorage.getPhotoFile(fileId, type)
        .map(e => {
          let resourseUrl = this._domSanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(e))

          this._photos.push({
            src: resourseUrl,
            caption: null,
            thumb: null,
            fileId: fileId
          });

          return resourseUrl;
        })

      this._fileUrls[fileId] = url;
    }

    return url;
  }

  private downloadPhoto(fileId: string, type: PhotoType, photoNumber: number): Observable<Blob> {
    if (fileId == null || type == null)
      return null;

    this._fileStorage
      .getPhotoFile(fileId, type)
      .subscribe(result => saveAs(result, `ПО_${this._plannedService.serviceObject.name}_${photoNumber}${this.getFileExtension(fileId)}`))
  }

  private downloadArchive(): Observable<Blob> {
    if (this._plannedService == null)
      return null;

    this._fileStorage
      .getPlannedServicePhotoAchive(this._plannedService.id)
      .subscribe(result => saveAs(result, "ПО_" + this._plannedService.serviceObject.name + ".zip"));
  }

  private getFileExtension(fileName: string): string {
      let splittedString = fileName.split('.');

      if (splittedString.length > 1)
      {
        return "." + splittedString.pop();
      }

      return "";
  }

  private _fileUrls: { [fileId: string]: Observable<SafeUrl> } = {};

  private clearSubscription() {
    if (this.assetPathLoadSubscription)
      this.assetPathLoadSubscription.unsubscribe();

    this.assetPathLoadSubscription = null;
    this._plannedService = null;
  }

  private convertPlannedServiceStatusToText(status: PlannedService.Status): string {
    switch (status) {
      case PlannedService.Status.Planned:
        return "Запланировано";
      case PlannedService.Status.Done:
        return "Выполнено";
      case PlannedService.Status.Canceled:
        return "Отменено";
      default:
        return "";
    }
  }

  private assetPathLoadSubscription: Subscription;
  private ErrorStateEnum = PlannedServiceDetailsComponent.ErrorState;
}


export namespace PlannedServiceDetailsComponent {
  export enum ErrorState {
    /**
     * Нет ошибок
     */
    None,
    /**
     * Сервер не может предоставить данные по объекту обслуживания (его не существует или доступ к данным запрещен)
     */
    NoData,
    /**
     * Другая ошибка
     */
    UnknownError
  }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/plannedService/details/plannedService-details.component.ts